import React from 'react';
import { PropTypes } from 'utils/wrappers';
import Price from 'components/Common/Property/Price';

const PayInFull = ({ property, className }) => {
    const total = property.finances.price;
    const discountPercentage = 0.05;
    const discount = Math.round(total * discountPercentage);
    const processingFee = property.finances.processingFee;

    return (
        <div className='payment-calculator-pay-in-full'>
            <h4 className={'font-weight-bold'}>Pay in Full</h4>
            <div className={'row mb-2'}>
                <div className={'col-6'}>Purchase Price</div>
                <div className={'col-6 text-right'}>
                    <Price value={total} />
                </div>
            </div>
            <div className={'row mb-2'}>
                <div className={'col-6'}>Discount ({discountPercentage * 100}%)</div>
                <div className={'col-6 text-right'}>
                    - <Price value={discount} />
                </div>
            </div>
            <div className={'row mb-2'}>
                <div className={'col-6'}>Processing Fee</div>
                <div className={'col-6 text-right'}>
                    + <Price value={processingFee} />
                </div>
            </div>
            <div className={'row mb-2 font-weight-bold'}>
                <div className={'col-6'}>Total due Today</div>
                <div className={'col-6 text-right'}>
                    <Price value={total - discount + processingFee} />
                </div>
            </div>
        </div>
    );
};

PayInFull.propTypes = {
    property: PropTypes.shape({
        listingId: PropTypes.string.isRequired,
        finances: PropTypes.shape({
            price: PropTypes.number.isRequired,
            processingFee: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
    className: PropTypes.string,
};

export default PayInFull;
